import { render, staticRenderFns } from "./qTableHeader.vue?vue&type=template&id=548e7a37&"
import script from "./qTableHeader.vue?vue&type=script&lang=ts&"
export * from "./qTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports